// src/mocks/config.ts
// централизованные флаги/настройки моков

// включение моков для продуктов: из env или из localStorage
const env = String(process.env.REACT_APP_MOCKS || '').toLowerCase();
const envOn = env === '1' || env === 'true';
const lsOn = localStorage.getItem('mock.enable') === '1';

export const MOCKS_ENABLED = envOn || lsOn;

// включение моков для уведомлений/вопросов (orders, notifications, questions)
const envOrders = String(process.env.REACT_APP_MOCK_ORDERS || '').toLowerCase();
export const MOCK_ORDERS_ENABLED = envOrders === '1' || envOrders === 'true';

// включение моков для расходов (expenses)
const envExpenses = String(process.env.REACT_APP_MOCK_EXPENSES || '').toLowerCase();
export const MOCK_EXPENSES_ENABLED = envExpenses === '1' || envExpenses === 'true';

// очищать стора перед посевом (полезно на dev)
export const CLEAR_BEFORE_SEED = true;

// ключ «посеяно» — чтобы не дублировать записи каждый раз
export const SEEDED_FLAG_KEY = 'demo.mocks.seeded.v1';

// сколько записей генерить
export const MOCKS_COUNTS = {
  notifications: 20,
  expenses: 200,
  inbounds: 60,
} as const;
